import { useEffect } from 'react'

// TODO: Temporary solution for lead.css styles overrides mantine styles from @hhgtech/hhg-components
// This should be removed once we have a proper solution for style management.

// @ts-ignore
import leadCss from '!raw-loader!@hhgtech/hhg-components/lead.css'

export const LeadCss = () => {
  useEffect(() => {
    const id = 'lead-css-style'
    if (!document.getElementById(id)) {
      const style = document.createElement('style')
      style.id = id
      style.innerHTML = leadCss
      document.head.appendChild(style)
    }
  }, [])

  return null
}
